import React from 'react';
import {observer} from 'mobx-react';
import {loader, t, withDisplay} from 'shared/core';
import ReminderEditState from 'company_settings/reminders/state/ReminderEditState';
import CreateReminderFor from './CreateReminderFor';
import SendReminderTo from './SendReminderTo';
import ReminderDateSelector from './ReminderDateSelector';
import {FormattedMessage} from 'react-intl';
import {Button, Display} from 'components';
import reminderEditStore from 'company_settings/reminders/state/ReminderEditStore';

const Header = observer(({reminder}) => {
  if (reminder.isNew) {
    return (
      <FormattedMessage id='company_settings.reminders.Add Reminder'/>
    );
  }

  return (
    <FormattedMessage id='company_settings.reminders.Edit Reminder'/>
  );
});

const Nav = observer(() => {
  return (
    <Display backTitle={t('company_settings.reminders.Reminders')}
             backPath='/reminders'/>
  );
});

const ReminderEditContainer = observer(({uiState}) => {
  const {reminder} = uiState;

  return (
    <div className='Container'>
      <div className='clearfix'>
        <div className='col col-12 md-col-10 lg-col-9 rounded bg-white box-shadow-1 px3 py2'>
          <div className='clearfix px2'>
            <div className='col col-12 md-col-10 lg-col-8 my2'>
              <div className='mb3 pr2 h2'>
                <Header reminder={reminder}/>
              </div>
              <CreateReminderFor uiState={uiState}/>
              <SendReminderTo uiState={uiState}/>
            </div>
            <div className='col col-12 md-col-11 my2'>
              <ReminderDateSelector uiState={uiState}/>
            </div>
          </div>
        </div>
      </div>
      <Button className={`Btn Btn--large mt3`} onClick={() => uiState.saveReminder()}>
        <FormattedMessage id='company_settings.reminders.Save reminder'/>
      </Button>
    </div>
  );
});

async function load({match, history}) {
  const id = match.params.id;
  const uiState = new ReminderEditState(reminderEditStore, history);
  await uiState.load(id === 'new' ? undefined : id);
  return {uiState};
}

export default withDisplay(loader(ReminderEditContainer, load), Nav);
